import { render, staticRenderFns } from "./UploadPhotoModal.vue?vue&type=template&id=54706e4a"
import script from "./UploadPhotoModal.vue?vue&type=script&lang=js"
export * from "./UploadPhotoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports